var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _polygon2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _rect, _rect2, _rect3, _rect4, _path40, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagina5Italia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1157.8 1183.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #010202;\n      }\n\n      .st2 {\n        fill: #d0d2e2;\n      }\n\n      .st3 {\n        fill: #004a95;\n      }\n\n      .st4 {\n        fill: url(#Sfumatura_senza_nome_89);\n      }\n\n      .st5 {\n        fill: #1d2c4f;\n      }\n\n      .st6, .st7 {\n        fill: #fff;\n      }\n\n      .st7, .st8 {\n        fill-opacity: 0;\n      }\n\n      .st8 {\n        fill: #010101;\n      }\n\n      .st9 {\n        fill: url(#Sfumatura_senza_nome_5);\n      }\n\n      .st10 {\n        fill: url(#Sfumatura_senza_nome_3);\n      }\n\n      .st11 {\n        fill: url(#Sfumatura_senza_nome_4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_89",
    "data-name": "Sfumatura senza nome 89",
    x1: 578.9,
    y1: 1183.9,
    x2: 578.9,
    y2: 235.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_5",
    "data-name": "Sfumatura senza nome 5",
    x1: 602.2,
    y1: 708.8,
    x2: 602.2,
    y2: 782.8,
    gradientTransform: "translate(0 1165.0443) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c93441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc3d50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_4",
    "data-name": "Sfumatura senza nome 4",
    x1: 533.2,
    y1: 708.8,
    x2: 533.2,
    y2: 782.8,
    gradientTransform: "translate(0 1165.0443) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21924a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cae65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_3",
    "data-name": "Sfumatura senza nome 3",
    x1: 567.7,
    y1: 708.8,
    x2: 567.7,
    y2: 782.8,
    gradientTransform: "translate(0 1165.0443) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1157.8 1183.9 0 1183.9 341.3 235.2 786.8 235.2 1157.8 1183.9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M566.3,518.3c143.1,0,259.1-116,259.1-259.1S709.4,0,566.3,0s-259.1,116-259.1,259.1,116,259.1,259.1,259.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M566.1,424.6c91.4,0,165.4-74.1,165.4-165.4s-74.1-165.4-165.4-165.4-165.4,74.1-165.4,165.4,74.1,165.4,165.4,165.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M261.8,188.3l19.1,12.3s-18.2,16.7-23.2,16.1c-5-.6-16.1-6.7-17.9-8.6-1.8-1.9-.9-9.8-.9-9.8l23-10h-.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.5,217.2c-5.2-.6-16.4-6.9-18.2-8.8-1.9-2-1.1-9.4-1.1-10.2s.1-.3.3-.4l23-10h.5l19.1,12.3c.1,0,.2.2.2.4s0,.3-.2.4c-.7.7-17.9,16.3-23.4,16.3h-.3M261.7,188.8l-22.5,9.8c-.2,2.3-.5,7.7.8,9.1,1.7,1.8,12.7,7.9,17.6,8.5,3.8.4,17-10.7,22.4-15.5l-18.3-11.8h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M237,164.9l25.5,23.2s-2.3,6-11.9,12.9c-9.7,6.8-13.6-36-13.6-36"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M280.4,224.5c-.3.8-.2,1.8.2,2.6.9,1.7,2.9,2.3,4.5,1.4l99.4-50.2c1.7-.9,2.3-2.9,1.5-4.5-.9-1.7-2.9-2.3-4.5-1.5l-99.4,50.2c-.8.4-1.4,1.1-1.6,1.9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M464.4,72.3c36.8,11.8,57.2,51.4,45.3,88.2-5.7,17.8-18.1,32.4-34.7,40.9-16.7,8.6-35.7,10.1-53.5,4.4-17.8-5.7-32.4-18.1-40.9-34.7-8.6-16.7-10.1-35.7-4.4-53.5.2-.5.3-1,.5-1.4,12.4-35.9,51.4-55.6,87.8-43.9M504,158.7c10.8-33.7-7.8-69.8-41.4-80.6-33.7-10.8-69.8,7.8-80.6,41.4-10.8,33.7,7.8,69.8,41.4,80.6,16.3,5.2,33.7,3.8,48.9-4,14.8-7.6,25.9-20.4,31.3-36.1.2-.4.3-.9.4-1.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M398.5,110.3c.1,0,.3,0,.4-.2,11.8-18,33.1-26.9,54.2-22.8.2,0,.5,0,.5-.4s-.1-.5-.4-.5c-10.5-2.1-21.3-.9-31.2,3.3-9.8,4.2-18.1,11-23.9,19.9-.1.2,0,.5.1.6h.2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M442.5,192.7c9.7,0,19.4-2.5,27.8-7.5,8.5-5,15.4-12.3,20-21,.1-.2,0-.5-.2-.6s-.5,0-.6.2c-9.2,17.4-27.3,28.2-47,28-.2,0-.5.2-.5.4s.2.5.4.5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.5,208.4c.1,0,.2,0,.3-.1.2-.2.3-.5,0-.7l-5.6-7.3c-.2-.2-.5-.3-.7,0-.2.2-.3.5,0,.7l5.6,7.3c0,.1.2.2.4.2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.6,211.4c.1,0,.2,0,.3-.1.2-.2.3-.5,0-.7l-5.6-7.3c-.2-.2-.5-.3-.7,0-.2.2-.3.5,0,.7l5.6,7.3c0,.1.2.2.4.2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.2,129.6c.3-3.7,1.9-7.4,4.5-10,1.1-1.1,2.5-2.1,4-2.6s3.3-.4,4.6.5h0c1.5,1,3.4,1.1,4.9,0,1-.6,2-1.1,3.2-1.4,2.9-.6,6,.3,8.1,2.3s3.1,5.1,2.5,8c-.7,3.7-3.7,6.6-6.8,8.6-3.2,2-6.8,3.5-10.5,4.1-3,.5-6.2.4-9.2-.4-1.3-.4-2.4-.6-3.2-1.7-.8-1-1.3-2.1-1.7-3.3-.4-1.4-.5-2.9-.4-4.3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "232.8 141 219.9 156.8 232.5 164 245.7 145.4 232.8 141"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M236,143.2c-1.3.4-2.9-.1-3.8-1.2-.9-1.1-1.2-2.6-.8-3.9.2-.7.5-1.3,1.1-1.7.8-.5,1.8-.4,2.6,0,.8.5,1.4,1.2,1.8,2,0,0,.9-.6,3.6-2.6,3.1-2.2-.3-7-.3-7,3.8,2.4,7.8,3,11.8,1.8,1.7,3.5,2,7.6.8,11.3-.7,2.1-1.9,4.2-3.8,5.5-2.1,1.4-5,1.6-7.4.8-2.4-.9-4.4-2.7-5.8-4.9h.2Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.5,148.7c-2.4-.8-4.5-2.6-5.9-4.9-1.4.2-2.8-.4-3.8-1.4-1-1.2-1.3-2.8-.9-4.4.2-.6.5-1.5,1.4-2,.9-.6,2.1-.5,3.1,0,.6.4,1.2.9,1.7,1.7.5-.4,1.5-1.1,3.2-2.2.6-.4.9-.9,1-1.6.4-2.1-1.5-4.7-1.5-4.7-.1-.2-.1-.5,0-.6.2-.2.4-.2.6,0,3.7,2.3,7.5,2.9,11.4,1.8.2,0,.5,0,.6.3,1.7,3.6,2,7.9.9,11.7-.6,1.8-1.7,4.2-4,5.7-1.4.9-3.1,1.4-4.8,1.4s-2-.2-3-.5M241.5,130.1c.5,1.1,1,2.5.8,3.9-.2.9-.7,1.7-1.4,2.3-2.7,1.9-3.6,2.6-3.6,2.6-.1,0-.3.1-.4,0-.1,0-.3-.1-.3-.3-.5-.9-1-1.5-1.6-1.8-.7-.4-1.5-.4-2.1,0-.4.3-.8.8-.9,1.4-.3,1.2,0,2.5.7,3.5.8.9,2.1,1.3,3.2,1,.3,0,.5,0,.6.3v.2c1.3,2.2,3.2,3.7,5.4,4.5,2.4.8,5,.6,7-.7,2-1.4,3-3.6,3.6-5.2,1.1-3.4.8-7.3-.6-10.6-3.5.9-6.9.5-10.2-1.1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.4,141.3c.1,0,.3,0,.4-.1.2-.2.2-.5,0-.7-.7-.7-1.6-1.2-2.6-1.4-.3,0-.5.1-.6.4,0,.3.1.5.4.6.8.2,1.5.6,2.1,1.1,0,0,.2.1.3.1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.1,153.4c.1,0,.3,0,.4-.2l8.4-10.2c.2-.2.1-.5,0-.7s-.5-.1-.7,0l-8.4,10.2c-.2.2-.1.5,0,.7,0,0,.2.1.3.1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.6,161c.2,0,.3,0,.4-.2l8.7-11.7c.2-.2.1-.5-.1-.7-.2-.2-.5-.1-.7.1l-8.7,11.7c-.2.2-.1.5.1.7h.3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.6,131h.2c1.7-.8,3.1-2.3,3.8-4.1,0-.3,0-.6-.3-.6s-.5,0-.6.3c-.6,1.6-1.8,2.9-3.3,3.6-.3.1-.4.4-.2.7,0,.2.3.3.4.3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M181.3,218.1s-35.1,95.5-81.4,131.5c-4,3.1-6.3,7.8-6.2,12.8.3,14.4,3.9,43.9,26.9,62.8,2.5,2.1,6.4.4,6.5-2.9l.7-24.1s42.8-34.2,74.1-99.2c0,0,19.6,100.9,26.1,118.4,2,5.6,5,10.7,10.9,10.8l54.4,1c2.6,0,4-2.9,2.4-4.9l-13.9-17.3s-24.4-83.4-45.2-183.2l-55.2-5.7h-.1Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.2,429.7l-54.4-1c-6.5-.1-9.5-6-11.4-11.1-6-16.3-23.4-104.5-25.8-117-29.9,61.3-70.3,95.3-73.4,97.8l-.7,23.9c0,1.7-1,3.2-2.6,3.9-1.6.7-3.4.5-4.7-.6-22.7-18.8-26.7-47.7-27-63.2-.1-5.1,2.3-10.1,6.3-13.2,23.9-18.5,44.7-53.2,57.9-79.1,14.4-28,23.2-52,23.3-52.2,0-.2.3-.4.5-.3l55.2,5.7c.2,0,.4.2.4.4,20.2,97.1,44.2,179.8,45.2,183.1l13.8,17.2c.9,1.1,1,2.5.4,3.8-.6,1.2-1.8,2-3.2,2h0M181.6,218.6c-1.2,3.1-9.8,25.8-23.2,51.9-13.3,25.9-34.2,60.8-58.2,79.4-3.8,3-6.1,7.6-6,12.4.3,15.3,4.2,43.8,26.7,62.4,1,.9,2.4,1,3.6.5,1.2-.6,2-1.7,2-3l.7-24.1c0-.1,0-.3.2-.4.4-.3,43.1-34.9,73.9-99,0-.2.3-.3.5-.3s.4.2.4.4c.2,1,19.7,101,26.1,118.4,1.9,5.1,4.6,10.4,10.4,10.5l54.4,1h0c1,0,1.9-.5,2.3-1.4.4-.9.3-1.9-.3-2.7l-13.9-17.3v-.2c-.2-.8-24.6-84.4-45.1-182.9l-54.5-5.6h0ZM281.7,407h0Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.8,299.7c.2,0,.4-.1.5-.3,2.4-5.9,16.1-43.7,17.2-46.8l7.5-3.7c.2-.1.4-.4.2-.7-.1-.2-.4-.4-.7-.2l-7.7,3.8c0,0-.2.2-.2.3,0,.4-14.8,40.8-17.2,46.9,0,.3,0,.6.3.7h.2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.9,408.9h0l47.8-.6c.3,0,.5-.2.5-.5s-.2-.5-.5-.5l-47.8.6c-.3,0-.5.2-.5.5s.2.5.5.5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.8,398c0,0,.3,0,.4-.2.2-.2.2-.5,0-.7-14.6-12.6-22.7-29.6-22.9-47.7,0-.3-.2-.5-.5-.5h0c-.3,0-.5.2-.5.5.2,18.4,8.4,35.7,23.2,48.5,0,0,.2.1.3.1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M179.2,223.2l61.2,16.5c.9.2,1.8-.4,1.8-1.4l-.3-37.4,6-6.2s-8.7-45-28.1-42.2c-18.1,2.6-38,55.3-42.5,67.8-.5,1.3.4,2.8,1.8,3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.2,207.4s9.5,15.6,13.7,20.5c7.4,8.6,19.6,11.5,30.2,6.9l35.2-15.1c1.4-.6,2.9-.5,4.2.3,2.6,1.6,7.3,3.8,9.8-.2,0,0,4.2-.2,4.4-3.3,0,0,3.9-.5,4.1-3.4,0,0,2.2,0,2.4-2.4.2-2.3-6.2-16.3-23.6-14.3-9.2,1-20.6,3.7-29.6,6.9-20.8,7.5-21.4-3.3-23.4-8.9,0,0-12.7,1.3-27.4,12.9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.2,237.6c3.7,0,7.5-.7,11-2.2l35.2-15.1c1.2-.5,2.6-.4,3.7.3,2,1.2,4.8,2.6,7.3,2,1.2-.3,2.3-1,3-2.2,1.6-.2,4.2-1,4.5-3.4,1-.2,3.7-1,4-3.3,1-.2,2.3-.9,2.4-2.8.1-1.4-1.5-5.7-5.1-9.2-3.2-3.1-9.1-6.7-18.4-5.6-10.2,1.1-22.1,3.8-30.3,6.9-7.6,2.8-13,3.3-16.7,1.5-3.5-1.8-4.6-5.5-5.5-8.4-.2-.6-.3-1.1-.5-1.6,0-.3-.4-.4-.6-.3-.3,0-.4.4-.3.6.2.5.3,1,.5,1.6,1,3.2,2.1,7.1,6.1,9,3.9,1.9,9.6,1.5,17.5-1.4,8.2-3,19.9-5.7,30-6.8,9-1,14.5,2.3,17.6,5.3,3.6,3.5,4.9,7.4,4.8,8.4-.1,1.8-1.7,1.9-1.9,1.9-.3,0-.5.2-.5.5-.1,2.4-3.6,2.9-3.6,2.9-.2,0-.4.2-.4.5-.1,2.6-3.7,2.8-3.9,2.8s-.3,0-.4.2c-.7,1.1-1.5,1.7-2.5,1.9-2.2.5-4.8-.8-6.5-1.9-1.4-.9-3.1-1-4.7-.3l-35.2,15.1c-7.8,3.3-16.5,2.8-23.4-1.5-5.5-3.4-6.9-4.3-19.9-25.7,0-.2-.5-.3-.7-.2s-.3.5-.2.7c13.1,21.6,14.6,22.6,20.2,26.1,4,2.5,8.6,3.8,13.3,3.8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.1,219.6h.1c.3,0,.4-.3.4-.6-.4-2-1.6-3.8-3.2-5-.2-.2-.5-.1-.7,0-.2.2-.1.5,0,.7,1.4,1.1,2.4,2.7,2.8,4.5,0,.2.3.4.5.4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.5,216.4h0c.3,0,.5-.3.4-.6-.4-2.6-1.8-5-3.8-6.7-.2-.2-.5-.2-.7,0s-.2.5,0,.7c1.8,1.5,3.1,3.8,3.5,6.1,0,.2.3.4.5.4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.7,213h.1c.3,0,.4-.3.4-.6-.5-2.3-1.7-4.5-3.4-6.2s-.5-.2-.7,0-.2.5,0,.7c1.6,1.5,2.7,3.5,3.1,5.7,0,.2.3.4.5.4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.3,208.5h.2c.3,0,.4-.4.3-.6-2.9-8.3-7.6-23.6-7.6-23.8,0-.3-.4-.4-.6-.3-.3,0-.4.4-.3.6,0,.2,4.7,15.5,7.6,23.8,0,.2.3.3.5.3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.6,194.8h.1c.3,0,.4-.3.4-.6s-3.4-15.2-10.7-30.2c-.1-.2-.4-.4-.7-.2s-.4.4-.2.7c7.3,14.9,10.6,29.9,10.7,30,0,.2.3.4.5.4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M314.4,198.6s7.9-5.5,15.5-7.7c1.1-.3,6.8.9,7.8,1.2,1.2.4,1.7,5.3-3.3,4.1-1-.2-13.7,7.4-13.7,7.4,0,0-3.5-3.5-6.2-4.9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.3,203.9s-3.4-3.5-6.1-4.8c-.2,0-.3-.2-.3-.4s0-.3.2-.4c0,0,8-5.6,15.7-7.8,1.3-.4,7.2.9,8.1,1.2.9.3,1.4,1.8,1,3.2-.2.6-1.1,2.7-4.5,1.9-1,.1-7.6,3.8-13.4,7.3h-.3c-.1,0-.3,0-.4-.1M334.5,195.6c1.8.5,3,0,3.4-1.1.3-.9-.1-1.9-.4-1.9-1.1-.4-6.6-1.5-7.5-1.2-6.2,1.8-12.6,5.8-14.7,7.2,2.2,1.3,4.6,3.6,5.4,4.3,5.7-3.4,12.4-7.3,13.7-7.3h0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M334.7,200.7l3.6,3.6c.9.9,2.3.9,3.2,0s.9-2.3,0-3.2l-3.6-3.6c-.9-.9-2.3-.9-3.2,0s-.9,2.3,0,3.2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.9,204.7l-3.6-3.6c-1.1-1.1-1-2.8,0-3.9,1.1-1.1,2.8-1,3.9,0l3.6,3.6c1.1,1.1,1,2.8,0,3.9-.5.5-1.3.8-2,.8s-1.4-.3-1.9-.8M335.1,197.9c-.7.7-.7,1.8,0,2.5l3.6,3.6c.7.7,1.8.7,2.5,0s.7-1.8,0-2.5l-3.6-3.6c-.3-.3-.8-.5-1.2-.5s-.9.2-1.2.5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M324.3,209.6l2.9,3c.9.9,2.3.9,3.2,0s.9-2.3,0-3.2l-2.9-3c-.9-.9-2.3-.9-3.2,0s-.9,2.3,0,3.2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.8,212.9l-2.9-3c-1.1-1.1-1-2.8,0-3.9.5-.5,1.2-.8,2-.8s1.4.3,1.9.8l2.9,3c1.1,1.1,1,2.8,0,3.9-.5.5-1.3.8-2,.8s-1.4-.3-1.9-.8M324.7,206.7c-.3.3-.5.8-.5,1.2s.2.9.5,1.2h0l2.9,3c.7.7,1.8.7,2.5,0s.5-.8.5-1.2-.2-.9-.5-1.2l-2.9-3c-.3-.3-.8-.5-1.2-.5s-.9.2-1.2.5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M330.6,203.1l5.1,5.1c.9.9,2.3.9,3.2,0s.9-2.3,0-3.2l-5.1-5.1c-.9-.9-2.3-.9-3.2,0s-.9,2.3,0,3.2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.4,208.5l-5.1-5.1h0c-1.1-1.1-1-2.8,0-3.9,1.1-1.1,2.8-1,3.9,0l5.1,5.1c.5.5.8,1.2.8,2s-.3,1.4-.8,1.9-1.3.8-2,.8-1.4-.3-1.9-.8M331,200.2c-.7.7-.7,1.8,0,2.5l5.1,5.1c.7.7,1.8.7,2.5,0s.7-1.8,0-2.5l-5.1-5.1c-.3-.3-.8-.5-1.2-.5s-.9.2-1.2.5M330.6,203.1h0Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M327.3,206.2l4.4,4.4c.9.9,2.3.9,3.2,0s.9-2.3,0-3.2l-4.4-4.4c-.9-.9-2.3-.9-3.2,0s-.9,2.3,0,3.2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M331.4,211l-4.4-4.4h0c-1.1-1.1-1-2.8,0-3.9s2.8-1,3.9,0l4.4,4.4c1.1,1.1,1,2.8,0,3.9-.5.5-1.2.8-2,.8s-1.4-.3-1.9-.8M327.7,203.4c-.7.7-.7,1.8,0,2.5l4.4,4.4c.7.7,1.8.7,2.5,0s.7-1.8,0-2.5l-4.4-4.4c-.3-.3-.8-.5-1.2-.5s-.9.2-1.2.5M327.3,206.2h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 515.9,
    y: 382.2,
    width: 103.5,
    height: 73.9,
    rx: 4,
    ry: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 584.9,
    y: 382.2,
    width: 34.5,
    height: 73.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    x: 515.9,
    y: 382.2,
    width: 34.5,
    height: 73.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 550.4,
    y: 382.2,
    width: 34.5,
    height: 73.9
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M619.4,388.8v3.3c0-3.6-2.9-6.6-6.6-6.6h-90.4c-3.6,0-6.6,2.9-6.6,6.6v-3.3c0-3.6,2.9-6.6,6.6-6.6h90.4c3.6,0,6.6,2.9,6.6,6.6Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M619.4,446.3v3.3c0,3.6-2.9,6.6-6.6,6.6h-90.4c-3.6,0-6.6-2.9-6.6-6.6v-3.3c0,3.6,2.9,6.6,6.6,6.6h90.4c3.6,0,6.6-2.9,6.6-6.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagina5Italia);
export default __webpack_public_path__ + "static/media/pagina_5_italia.b6394dad7ccfd34b8b76cf6d26b37659.svg";
export { ForwardRef as ReactComponent };